module.exports = {
	path: '/home',
	name: 'home',
	component: () => import('../views/Home.vue'),
	meta: { title: '首页', icon: 'el-icon-s-help' }
}